import { Injectable } from '@angular/core';
import { ColumnApi, GridApi } from 'ag-grid';
import { DataExportHelper } from '../helpers/data-export.helper';
import { ExportRowsEnum, ExportResultEnum } from '../enums/data-export.enum';

@Injectable()
export class ExcelExportService {

  export(
    gridApi: GridApi,
    columnApi: ColumnApi,
    rowsMode: ExportRowsEnum,
    fileName: string,
    sheetName: string,
    excluded: string[] = []
  ): ExportResultEnum {
    if (!gridApi || !columnApi) {
      return ExportResultEnum.GridUnavailable;
    }
    if (rowsMode === ExportRowsEnum.Selected && !DataExportHelper.selectedCount(gridApi)) {
      return ExportResultEnum.EmptySelection;
    }
    const rows = DataExportHelper.rowsFromGrid(gridApi, columnApi, rowsMode, excluded);
    DataExportHelper.write(rows, fileName, sheetName, 'xlsx');
    return ExportResultEnum.Success;
  }
}


// WEBPACK FOOTER //
// ./src/app/core/services/excel-export.service.ts